<template>
  <div class="setting-group-page">
    <user-invite-dialog ref="userInviteDialog"></user-invite-dialog>
    <message-template-dialog ref="messageTemplateDialog"></message-template-dialog>
    <div class="page-content">
      <div class="mb-x2" v-if="!guestGroups.some(v => v.id === currentGroup.id)" layout="layout">
        <el-button class="el-button-mt" type="default" @click="onChangeBackEvent"
          ><i class="mdi mdi-arrow-left"></i>戻る</el-button
        >
      </div>
      <div class="card pt-x1">
        <el-tabs v-model="activeTab" @tab-click="tabChange">
          <el-tab-pane
            label="キャンペーン実施アカウント"
            name="accounts"
            v-if="currentGroup.isUserAdmin === 1 || guestGroups.some(v => v.id === currentGroup.id)"
          >
            <account-add-dialog ref="accountAddDialog" @next="openNextAuthDialog"></account-add-dialog>
            <instagram-next-auth ref="instagramNextAuth"></instagram-next-auth>
            <div class="mb-x2" layout layout-align="start-center">
              <el-button type="primary" @click="openAddAccountDialog" :disabled="remainAccountsCount <= 0"
                ><i class="mdi mdi-plus"></i>アカウントの追加</el-button
              >
              <div class="ml-x2">登録可能アカウント数: {{ remainAccountsCount }}</div>
            </div>
            <div v-if="error">
              <div class="message message-error">
                データ取得に失敗しました。恐れ入りますが、時間を置いて再度お試しください。
              </div>
            </div>
            <div v-else>
              <div class="message message-info" v-if="!accounts.length">
                アカウントが登録されていません。アカウントを追加してください。
              </div>
              <CampaignUnauthenticatedAccount
                v-else-if="isBeforeNttAaaSwitchover"
                :isGroupSetting="true"
                ref="campaignUnauthenticatedAccount"
              />
              <div class="mt-x2">
                <account-list :accounts="accounts"></account-list>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="ユーザー" name="users" v-if="currentGroup.isUserAdmin === 1">
            <div class="mb-x2" layout layout-align="start-center">
              <el-button type="primary" @click="openUserInviteDialog" :disabled="remainUsersCount <= 0"
                ><i class="mdi mdi-plus"></i>ユーザーの追加</el-button
              >
              <div class="ml-x2">登録可能ユーザー数: {{ remainUsersCount }}</div>
            </div>
            <div class="message message-error" v-if="error">
              データ取得に失敗しました。恐れ入りますが、時間を置いて再度お試しください。
            </div>
            <user-list v-else :users="users"></user-list>
          </el-tab-pane>
          <el-tab-pane label="ゲストユーザー" name="guest_users" v-if="currentGroup.isUserAdmin === 1">
            <div class="mb-x2" layout layout-align="start-center">
              <el-button type="primary" @click="openGuestUserInviteDialog" :disabled="remainGuestUsersCount <= 0"
                ><i class="mdi mdi-plus"></i>ゲストユーザーの追加</el-button
              >
              <div class="ml-x2">登録可能ユーザー数: {{ remainGuestUsersCount }}</div>
            </div>
            <div class="message message-info" v-if="!guestUsers.length && !error">
              ゲストユーザーのデータがありません。招待すると、ここに一覧表示されます。
            </div>
            <div class="message message-error" v-if="error">
              データ取得に失敗しました。恐れ入りますが、時間を置いて再度お試しください。
            </div>
            <user-list v-else :users="guestUsers" :isGuest="true"></user-list>
          </el-tab-pane>
          <el-tab-pane label="テンプレート" name="templates" v-if="!guestGroups.some(v => v.id === currentGroup.id)">
            <div class="mb-x2" layout layout-align="start-center">
              <el-button type="primary" @click="openMessageTemplateDialog(0)"
                ><i class="mdi mdi-plus"></i>テンプレートの追加</el-button
              >
            </div>
            <message-template-table
              :templates="templates"
              :total="templateTotal"
              :params="templateParam"
              :options="templateOption"
              :onChangeSortBy="onChangeSortBy"
              :onChangePagingNo="onChangePagingNo"
              :onChangeLimitCount="onChangeLimitCount"
              :openMessageTemplateDialog="openMessageTemplateDialog"
            ></message-template-table>
          </el-tab-pane>
          <el-tab-pane
            label="自己紹介キーワード判定"
            name="profile_keyword_settings"
            v-if="!guestGroups.some(v => v.id === currentGroup.id)"
            ><ProfileKeywordSettingLayout
          /></el-tab-pane>
          <el-tab-pane label="NGアカウント" name="ng_accounts" v-if="!guestGroups.some(v => v.id === currentGroup.id)">
            <ng-applicant-add-dialog ref="ngApplicantAddDialog"></ng-applicant-add-dialog>
            <div v-loading="loading" :element-loading-text="loadingText" element-loading-custom-class="csv-loading">
              <div class="mb-x2">
                <Message type="info">
                  キャンペーンへの応募を無効にしたいアカウントをNGアカウントとして追加できます。
                </Message>
              </div>
              <div class="mb-x2" layout="row" layout-align="space-between-center">
                <div>
                  <el-radio border v-model="snsType" label="twitter" @change="handleRadioChange('twitter')">X</el-radio>
                  <el-radio border v-model="snsType" label="instagram" @change="handleRadioChange('instagram')"
                    >Instagram</el-radio
                  >
                  <el-radio border v-model="snsType" label="tiktok" @change="handleRadioChange('tiktok')"
                    >TikTok</el-radio
                  >
                </div>
                <div layout layout-align="start-center">
                  <div class="search mr-x1" layout layout-align="start-center">
                    <el-input
                      v-model="ngApplicantFilterName"
                      type="text"
                      @change="onChangeAccountName"
                      placeholder="検索(完全一致)"
                    >
                      <template slot="prepend"><i class="mdi mdi-magnify"></i></template>
                    </el-input>
                  </div>
                  <csv-download
                    :download="downloadCsv"
                    :disabled="currentGroup.contractStatus === 3 || ngApplicants.length === 0"
                  ></csv-download>
                </div>
              </div>
              <div class="mb-x2" layout layout-align="start-center">
                <el-button type="primary" @click="openNgApplicantDialog(0)"
                  ><i class="mdi mdi-plus"></i>NGアカウントの追加</el-button
                >
              </div>
              <ng-applicant-table
                :ngApplicants="ngApplicants"
                :options="ngApplicantOption"
                :onChangeSortBy="onChangeSortBy"
                :onChangePagingNo="onChangePagingNo"
                :onChangeLimitCount="onChangeLimitCount"
                :snsType="snsType"
              ></ng-applicant-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="利用制限" name="setting" v-if="currentGroup.isUserAdmin === 1">
            <group-setting></group-setting>
          </el-tab-pane>
          <el-tab-pane label="利用実績" name="billing_histories" v-if="currentGroup.isUserAdmin === 1">
            <billing-history-table
              :billingHistories="billingHistories"
              :options="billingHistoryOptions"
              :onChangeSortBy="onChangeSortBy"
              :onChangePagingNo="onChangePagingNo"
              :onChangeLimitCount="onChangeLimitCount"
            ></billing-history-table>
          </el-tab-pane>
          <el-tab-pane label="請求先情報" name="group_billing" v-if="currentGroup.isUserAdmin === 1">
            <message class="request-contact-text" type="info"
              >情報の変更については、右下のサポートチャットよりお問い合わせください。</message
            >
            <group-billing :groupBilling="groupBilling"></group-billing>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import CsvDownload from '@/client/components/_atoms/csv_download'
import Message from '@/client/components/_atoms/Message.vue'
import { CampaignUnauthenticatedAccount } from '@/client/components/_organisms'
import ProfileKeywordSettingLayout from '@/client/components/templates/ProfileKeywordSettingLayout.vue'
import api from '@/client/core/api'
import Util from '@/client/core/util'
import AccountAddDialog from '@/client/features/setting_group/account_add_dialog'
import AccountList from '@/client/features/setting_group/account_list'
import BillingHistoryTable from '@/client/features/setting_group/billing_history_table'
import GroupBilling from '@/client/features/setting_group/group_billing'
import GroupSetting from '@/client/features/setting_group/group_setting'
import InstagramNextAuth from '@/client/features/setting_group/instagram_next_auth'
import MessageTemplateDialog from '@/client/features/setting_group/message_template_dialog'
import MessageTemplateTable from '@/client/features/setting_group/message_template_table'
import NgApplicantAddDialog from '@/client/features/setting_group/ng_applicant_add_dialog'
import NgApplicantTable from '@/client/features/setting_group/ng_applicant_table'
import UserInviteDialog from '@/client/features/setting_group/user_invite_dialog'
import UserList from '@/client/features/setting_group/user_list'
import { formatDatetime } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useCampaignStore } from '@/client/store/useCampaignStore'
import { useNavbarStore } from '@/client/store/useNavbarStore'
import { useSettingGroupStore } from '@/client/store/useSettingGroupStore'
import { useSystemStore } from '@/client/store/useSystemStore'
import { isBeforeNttAaaSwitchover } from '@/common/utils'

export default defineComponent({
  components: {
    CsvDownload,
    AccountList,
    UserList,
    UserInviteDialog,
    AccountAddDialog,
    InstagramNextAuth,
    MessageTemplateTable,
    MessageTemplateDialog,
    NgApplicantTable,
    NgApplicantAddDialog,
    GroupSetting,
    BillingHistoryTable,
    GroupBilling,
    ProfileKeywordSettingLayout,
    CampaignUnauthenticatedAccount,
    Message
  },
  data() {
    return {
      snsType: 'twitter',
      activeTab: [
        'accounts',
        'users',
        'guest_users',
        'templates',
        'profile_keyword_settings',
        'ng_accounts',
        'setting',
        'billing_histories',
        'group_billing'
      ].includes(window.location.hash.substr(1))
        ? window.location.hash.substr(1)
        : 'accounts',
      ngApplicantFilterName: '',
      loading: false,
      loadingText: ''
    }
  },

  created() {
    if (this.currentGroup.isUserAdmin === 0) {
      this.activeTab = 'templates'
    }

    if (this.guestGroups.some(v => v.id === this.currentGroup.id)) {
      this.activeTab = 'accounts'
    }

    window.location.hash = this.activeTab

    const isGuest = this.guestGroups.some(v => v.id === this.currentGroup.id)

    this.setBreadcrumb([
      {
        name: isGuest ? '' : 'グループ設定',
        link: null
      }
    ])
    this.fetchData()
  },
  computed: {
    ...mapState(useSystemStore, {
      currentGroup: state => state.currentGroup,
      guestGroups: state => state.guestGroups
    }),
    ...mapState(useSettingGroupStore, [
      'accounts',
      'remainAccountsCount',
      'users',
      'guestUsers',
      'remainUsersCount',
      'remainGuestUsersCount',
      'error',
      'templates',
      'templateTotal',
      'templateParam',
      'ngApplicants',
      'ngApplicantTotal',
      'ngApplicantParam',
      'billingHistories',
      'groupBilling',
      'billingHistoryParam',
      'billingHistoryTotal',
      'billingHistoryStartMonth',
      'billingHistoryEndMonth'
    ]),
    isBeforeNttAaaSwitchover,
    templateOption() {
      return {
        total: this.templateTotal,
        pagingNo: this.templateParam.pagingNo,
        limitCount: this.templateParam.limitCount,
        sortBy: this.templateParam.sortBy
      }
    },
    ngApplicantOption() {
      return {
        total: this.ngApplicantTotal,
        pagingNo: this.ngApplicantParam.pagingNo,
        limitCount: this.ngApplicantParam.limitCount,
        sortBy: this.ngApplicantParam.sortBy
      }
    },
    billingHistoryOptions() {
      return {
        total: this.billingHistoryTotal,
        pagingNo: this.billingHistoryParam.pagingNo,
        limitCount: this.billingHistoryParam.limitCount,
        sortBy: this.billingHistoryParam.sortBy,
        startMonth: this.billingHistoryStartMonth ? moment(this.billingHistoryStartMonth).format('YYYY年MM月') : '-',
        endMonth: this.billingHistoryEndMonth ? moment(this.billingHistoryEndMonth).format('YYYY年MM月') : '-'
      }
    },
    ...mapState(useCampaignStore, {
      lastQueryParams: state => state.lastQueryParams
    })
  },
  watch: {
    // 現在グループIDが変更された場合
    'currentGroup.id'() {
      this.fetchData()
    },
    activeTab() {
      window.location.hash = this.activeTab
    },
    async templateParam() {
      const { shouldLeaveGroupSetting } = await this.fetchTemplates()

      if (shouldLeaveGroupSetting) {
        this.$router.push('/campaigns')
      }
    },
    async ngApplicantParam() {
      const { shouldLeaveGroupSetting } = await this.fetchNgApplicants(this.snsType)

      if (shouldLeaveGroupSetting) {
        this.$router.push('/campaigns')
      }
    },
    async billingHistoryParam() {
      const { shouldLeaveGroupSetting } = await this.fetchBillingHistories(this.currentGroup.id)

      if (shouldLeaveGroupSetting) {
        this.$router.push('/campaigns')
      }
    },
    snsType() {
      this.setParamNgApplicant({ pagingNo: 1 })
    }
  },
  methods: {
    ...mapActions(useNavbarStore, ['setBreadcrumb']),
    ...mapActions(useSettingGroupStore, [
      'reset',
      'fetchAccounts',
      'fetchUsers',
      'fetchGuestUsers',
      'fetchTemplates',
      'fetchNgApplicants',
      'fetchBillingHistories',
      'fetchGroupBilling',
      'setParamTemplate',
      'setParamNgApplicant',
      'fetchGroup',
      'setParamBillingHistory'
    ]),
    /**
     * タブを変更イベント
     */
    tabChange() {
      switch (this.activeTab) {
        case 'accounts':
          TrackingService.sendEvent('click:グループ設定|キャンペーン実施アカウント')
          break
        case 'users':
          TrackingService.sendEvent('click:グループ設定|ユーザー')
          break
        case 'guest_users':
          TrackingService.sendEvent('click:グループ設定|ゲストユーザー')
          break
        case 'templates':
          TrackingService.sendEvent('click:グループ設定|テンプレート')
          break
        case 'profile_keyword_settings':
          TrackingService.sendEvent('click:グループ設定|自己紹介キーワード設定')
          break
        case 'ng_accounts':
          TrackingService.sendEvent('click:グループ設定|NGアカウント')
          break
        case 'setting':
          TrackingService.sendEvent('click:グループ設定|利用制限')
          break
        case 'billing_histories':
          TrackingService.sendEvent('click:グループ設定|利用実績')
          break
        case 'group_billing':
          TrackingService.sendEvent('click:グループ設定|請求先情報')
          break
        default:
          break
      }

      this.fetchData()
    },

    /**
     * 選択中タブに該当するデータを取得
     */
    async fetchData() {
      if (this.guestGroups.some(v => v.id === this.currentGroup.id) && this.activeTab !== 'accounts') {
        this.activeTab = 'accounts'
      }

      let result = { shouldLeaveGroupSetting: false }

      switch (this.activeTab) {
        case 'accounts':
          // グループのアカウント一覧を取得
          result = await this.fetchAccounts(this.currentGroup.id)
          break
        case 'users':
          // グループのユーザー一覧を取得
          result = await this.fetchUsers(this.currentGroup.id)
          break
        case 'guest_users':
          // グループのゲストユーザー一覧を取得
          result = await this.fetchGuestUsers(this.currentGroup.id)
          break
        case 'templates':
          this.setParamTemplate({ groupId: this.currentGroup.id })
          break
        case 'ng_accounts':
          this.setParamNgApplicant({ groupId: this.currentGroup.id })
          break
        case 'setting':
          await this.fetchGroup(this.currentGroup.id)
          break
        case 'billing_histories':
          result = await this.fetchBillingHistories(this.currentGroup.id)
          break
        case 'group_billing':
          result = await this.fetchGroupBilling(this.currentGroup.id)
          break
        default:
          break
      }

      if (result.shouldLeaveGroupSetting) {
        this.$router.push('/campaigns')
      }
    },

    /**
     * 入力されたNGアカウント名からアカウント情報を取得
     */
    onChangeAccountName(value: string) {
      TrackingService.sendEvent('click:グループ設定|NGアカウント|検索')

      const params: { screenName: null | string } = { screenName: null }
      if (value !== '') {
        params.screenName = value
      }
      this.setParamNgApplicant(params)
    },

    /**
     * Open message template dialog
     * @param {number} templateId
     */
    openMessageTemplateDialog(templateId: number) {
      if (!templateId) {
        TrackingService.sendEvent('click:グループ設定|テンプレート|テンプレートの追加')
      } else TrackingService.sendEvent('click:グループ設定|テンプレート|編集')

      this.$refs.messageTemplateDialog.open(templateId)
    },

    /**
     * ページを変更イベント
     * @param {number} page ページ
     */
    onChangePagingNo(page: number) {
      switch (this.activeTab) {
        case 'templates':
          if (this.templateParam.pagingNo === page) {
            return
          }
          this.setParamTemplate({ pagingNo: page })
          break
        case 'ng_accounts':
          if (this.ngApplicantParam.pagingNo === page) {
            return
          }
          this.setParamNgApplicant({ pagingNo: page })
          break
        case 'billing_histories':
          if (this.billingHistoryParam.pagingNo === page) {
            return
          }
          this.setParamBillingHistory({ pagingNo: page })
          break
      }

      Util.scrollToTop()
    },

    /**
     * リミット数を変更イベント
     * @param {number} limitCount リミット数
     */
    onChangeLimitCount(limitCount: number) {
      switch (this.activeTab) {
        case 'templates':
          if (this.templateParam.limitCount === limitCount) {
            return
          }
          this.setParamTemplate({ limitCount })
          break
        case 'ng_accounts':
          if (this.ngApplicantParam.limitCount === limitCount) {
            return
          }
          this.setParamNgApplicant({ limitCount })
          break
        case 'billing_histories':
          if (this.billingHistoryParam.limitCount === limitCount) {
            return
          }
          this.setParamBillingHistory({ limitCount })
          break
      }
    },

    /**
     * ソートを変更イベント
     * @param {string} sortBy ソート
     */
    onChangeSortBy(sortBy: string) {
      switch (this.activeTab) {
        case 'templates':
          if (this.templateParam.sortBy === sortBy) {
            return
          }
          this.setParamTemplate({ sortBy })
          break
        case 'ng_accounts':
          if (this.ngApplicantParam.sortBy === sortBy) {
            return
          }
          this.setParamNgApplicant({ sortBy })
          break
        case 'billing_histories':
          if (this.billingHistoryParam.sortBy === sortBy) {
            return
          }
          this.setParamBillingHistory({ sortBy })
          break
      }
    },

    openUserInviteDialog() {
      TrackingService.sendEvent('click:グループ設定|ユーザー|ユーザーの追加')

      this.$refs.userInviteDialog.open()
    },

    openGuestUserInviteDialog() {
      TrackingService.sendEvent('click:グループ設定|ユーザー|ゲストユーザーの追加')

      this.$refs.userInviteDialog.open({ isGuest: true })
    },

    /**
     * キャンペーン実施アカウントダイアログを開く
     */
    async openAddAccountDialog() {
      TrackingService.sendEvent('click:グループ設定|キャンペーン実施アカウント|アカウントの追加')

      this.$refs.accountAddDialog.open()
    },

    openNextAuthDialog() {
      this.$refs.accountAddDialog.close()
      this.$refs.instagramNextAuth.open({ type: 'add' })
    },

    /**
     * NGアカウントの追加ダイアログを開く
     */
    openNgApplicantDialog() {
      this.$refs.ngApplicantAddDialog.open(this.snsType)
    },

    /**
     * CSVダウンロード
     * @returns {Promise<{filename?: string, data?: any, error?: string}>}
     */
    async downloadCsv(): Promise<{ filename?: string; data?: any; error?: string }> {
      TrackingService.sendEvent('click:グループ設定|NGアカウント|CSVダウンロード')

      const params = Object.assign({}, this.ngApplicantParam, {
        limitCount: 1000
      })

      const total = this.ngApplicantOption.total
      let ngApplicants = []

      this.loading = true

      // 1000件ごとに取得する
      for (let count = 0; count < total; count += 1000) {
        const result = await api.get(`/${this.snsType}_ng_applicants`, {
          params
        })

        if (!result.data) {
          this.loading = false
          return {
            error: 'ERROR_LOADING'
          }
        }

        ngApplicants = ngApplicants.concat(result.data.ngApplicants)

        this.loadingText = `CSVファイルの作成中です。しばらくお待ちください。\n ${ngApplicants.length}件 / ${total}件`

        params.pagingNo = params.pagingNo + 1
      }

      const filename = `${this.snsType}_ng_applicants_${moment().format('YYYY_MM_DD')}`

      const csvData = []
      csvData.push(['ユーザー名', '作成日時'])

      // CSVデータを格納
      ngApplicants.forEach(applicant => {
        const datetime = formatDatetime(applicant.created)
        csvData.push([applicant.screenName, datetime])
      })

      this.loading = false

      return {
        filename,
        data: csvData
      }
    },

    onChangeBackEvent() {
      switch (this.activeTab) {
        case 'accounts':
          TrackingService.sendEvent('click:グループ設定|キャンペーン実施アカウント|戻る')
          break
        case 'users':
          TrackingService.sendEvent('click:グループ設定|ユーザー|戻る')
          break
        case 'guest_users':
          TrackingService.sendEvent('click:グループ設定|ゲストユーザー|戻る')
          break
        case 'templates':
          TrackingService.sendEvent('click:グループ設定|テンプレート|戻る')
          break
        case 'profile_keyword_settings':
          TrackingService.sendEvent('click:グループ設定|自己紹介キーワード設定|戻る')
          break
        case 'ng_accounts':
          TrackingService.sendEvent('click:グループ設定|NGアカウント|戻る')
          break
        case 'setting':
          TrackingService.sendEvent('click:グループ設定|利用制限|戻る')
          break
        case 'billing_histories':
          TrackingService.sendEvent('click:グループ設定|利用実績|戻る')
          break
        case 'group_billing':
          TrackingService.sendEvent('click:グループ設定|請求先情報|戻る')
          break
        default:
          break
      }

      const query = this.lastQueryParams || {}
      this.$router.push({ path: '/campaigns', query })
    },

    handleRadioChange(value: string) {
      TrackingService.sendEvent(`radio:グループ設定|NGアカウント|${value === 'twitter' ? 'X' : value}`)
    }
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    // グループ設定ストアをリセット
    this.reset()
    next()
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.setting-group-page {
  :deep(.csv-loading) {
    .el-loading-spinner {
      top: 40vh;

      .el-loading-text {
        white-space: pre-line;
      }
    }
  }

  .search {
    :deep(.el-input__inner) {
      height: $spacing-unit * 4;
    }
  }

  .request-contact-text {
    margin-bottom: 2 * $spacing-unit;
  }
}
</style>
